(function () {
    'use strict';

    function ServiceItemSchedulesController($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService) {

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.generateTimeInfo = generateTimeInfo;
        $ctrl.showTimingInfo = showTimingInfo;
        $ctrl.backToScheduleInfo = backToScheduleInfo;
        $ctrl.saveSchedule = saveSchedule;
        $ctrl.schSelected = false;
        $ctrl.schSaved = false;
        $ctrl.step = 0;
        $ctrl.schedulerApi = {refresh: 'not set'};
        $ctrl.generateTimesUntil = generateTimesUntil;
        $ctrl.session_date = new Date();
        $ctrl.scheduleType_changed = scheduleType_changed;
        $ctrl.canSelectMultipleTimes = false;
        $ctrl.hasDedicateSchedule = false;
        $ctrl.session_capacity = 1;
        $ctrl.gapTime = 0;
        $ctrl.session_discount = 0;
        $ctrl.showAdvanced = showAdvanced;
        $ctrl.showAdvancedSetting = false;


        $timeout(function () {
            loadAll();
            loadPage();

        });

        function setScheduleTypeFlags() {
            if ($ctrl.selectedScheduleInfo) {
                switch ($ctrl.selectedScheduleInfo.scheduleType) {
                    case 'BASED_ON_COMPANY_SCHEDULE':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = false;
                        break;
                    case 'PRIMARY':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = true;
                        break;
                    case 'FIXED_TIME_SESSIONS':
                        break;
                    case 'FLOAT_TIME_SESSIONS':
                        $ctrl.canSelectMultipleTimes = true;
                        $ctrl.hasDedicateSchedule = true;
                        break;

                }
            }
        }

        function updateScheduleTypeFromFlags() {
            if ($ctrl.selectedScheduleInfo.scheduleType != 'FIXED_TIME_SESSIONS') {
                $ctrl.selectedScheduleInfo.scheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                if ($ctrl.hasDedicateSchedule) {
                    $ctrl.selectedScheduleInfo.scheduleType = 'PRIMARY';

                } else {
                    $ctrl.canSelectMultipleTimes = false;
                }
                if ($ctrl.canSelectMultipleTimes)
                    $ctrl.selectedScheduleInfo.scheduleType = 'FLOAT_TIME_SESSIONS';
            }

        }

        function showTimingInfo() {
            $ctrl.timingInfo = $ctrl.selectedScheduleInfo.timingInfo;
            $ctrl.step = 1;
        }

        $ctrl.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }

        function saveSchedule() {
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            updateScheduleTypeFromFlags();
            TimingInfo.saveScheduleInfo().save($ctrl.selectedScheduleInfo, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.selectedId = sch.id;
                $ctrl.timingInfo = sch.timingInfo;
                $ctrl.step = 1;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                refreshList();
            });
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate($ctrl.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save($ctrl.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                $ctrl.timingInfo = timingInfo;
                $ctrl.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if ($ctrl.schedulerApi.refreshScheduler)
                $ctrl.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            $ctrl.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('scheduleType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            refreshList();


        }

        function refreshList() {
            if (!$ctrl.serviceItemId) $ctrl.scheduleInfos = [];
            else {
                ScheduleInfoCustom.primaryScheduleInfosByServiceItem($ctrl.serviceItemId).query(function (schs) {
                    $ctrl.scheduleInfos = schs;

                    if (!$ctrl.schSelected) {
                        if (schs.length == 0) $ctrl.newItem();
                        else $ctrl.editItem(schs[0]);
                    }
                });
            }
        }

        function newItem() {
            //
            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            $ctrl.schSelected = true;
            $ctrl.schSaved = false;
            updateTabs();

        }

        $ctrl.add_session = addSession;
        $ctrl.remove_session = removeSession;

        function removeSession(item) {
            var index = $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.indexOf(item);

            if (index > -1) {
                $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(index, 1);
            }

        }

        function addSession() {

            var isValid = validateTimesession();
            if (isValid) {
                var sessions = splitDurationIntoTimeSession();
                var i = 0;
                angular.forEach(sessions, function (ts) {
                    if (!isInList(ts)) {
                        i++
                        $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(0, 0, ts);
                    }
                })

                $('#closeDialog').click();
                AlertService.info('global.messages.info.newFixedTimeSessionAdded', {n: i});
            }
        }

        function validateTimesession() {
            if (!$ctrl.gapTime)
                $ctrl.gapTime = 0;

            var isValid = true;
            if (!$ctrl.session_date) {
                AlertService.error("error.time_session_date_is_required");
                isValid = false;
            } else if (!$ctrl.from_session_time || !$ctrl.to_session_time) {
                AlertService.error("error.start_and_end_time_is_required");
                isValid = false;
            } else if (!$ctrl.session_capacity) {
                AlertService.error("error.time_session_capacity_is_required");
                isValid = false;
            } else

                return isValid;
        }

        function splitDurationIntoTimeSession() {

            var retList = [];
            var from = $ctrl.from_session_time;
            var to = $ctrl.to_session_time;
            var duration = $ctrl.duration;
            var gap = $ctrl.gapTime;
            var dur_in_min = (to.getHours() - from.getHours()) * 60 + (to.getMinutes() - from.getMinutes());
            if (dur_in_min > 15) {
                if ($ctrl.duration && $ctrl.duration >= 15) {
                    if ($ctrl.duration > dur_in_min) {
                        $ctrl.duration = dur_in_min;
                        var newTimeSession = {
                            spanDate: $ctrl.session_date,
                            startTime: from,
                            endTime: to,
                            capacity: $ctrl.session_capacity,
                            discount: $ctrl.session_discount,
                            comment: $ctrl.session_comment,
                            timeSessionType: 'FIXED'
                        };
                        retList.push(newTimeSession);
                    } else {
                        var partsCount = dur_in_min / (duration + gap);
                        var start = moment(from);

                        for (var i = 0; i < partsCount; i++) {

                            var newTimeSession = {
                                spanDate: $ctrl.session_date,
                                startTime: start.toDate(),
                                endTime: start.add(duration, 'minutes').toDate(),
                                capacity: $ctrl.session_capacity,
                                discount: $ctrl.session_discount,
                                comment: $ctrl.session_comment,
                                timeSessionType: 'FIXED'
                            };
                            retList.splice(0, 0, newTimeSession);
                            start = start.add(gap, 'minutes');
                        }
                    }
                } else {
                    $ctrl.duration = dur_in_min;
                    var newTimeSession = {
                        spanDate: $ctrl.session_date,
                        startTime: from,
                        endTime: to,
                        capacity: $ctrl.session_capacity,
                        discount: $ctrl.session_discount,
                        comment: $ctrl.session_comment,
                        timeSessionType: 'FIXED'
                    };
                    retList.push(newTimeSession);
                }
            } else {
                AlertService.error("error.start_time_must_be_before_end_time");
            }
            return retList;
        }

        function isInList(timeSession) {
            if (timeSession.spanDate && timeSession.startTime && timeSession.endTime) {
                var exists = false;
                angular.forEach($ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes, function (time) {
                    if (datesAreEqual(time.spanDate, timeSession.spanDate) &&
                        timesAreEqual(time.startTime, timeSession.startTime) &&
                        timesAreEqual(time.endTime, timeSession.endTime))
                        exists = true;
                });
                if (exists) {
                    AlertService.error("error.time_session_date_time_is_repeated");
                    return true;
                } else {
                    return false;
                }


            }
            return false;
        }

        function editItem(id) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                updateTabs();
            });

        }

        function updateTabs() {
            setScheduleTypeFlags();
            if ($ctrl.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            $ctrl.formState = 'list';
            $ctrl.selectedScheduleId = '';
            refreshList();
        }

        function datesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("YYMMDD") == dm2.format("YYMMDD"))

        }

        function timesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("HH:mm") == dm2.format("HH:mm"))

        }


        function scheduleType_changed() {
            updateScheduleTypeFromFlags();
            // for now just support HOURLY
            if ($ctrl.selectedScheduleInfo != null && $ctrl.selectedScheduleInfo.scheduleType != null
                && $ctrl.selectedScheduleInfo.scheduleType == 'FLOAT_TIME_SESSIONS') {
                $ctrl.selectedScheduleInfo.floatingTimeType = 'HOURLY';
            } else {
                $ctrl.selectedScheduleInfo.floatingTimeType = null;
            }
        }

        function showAdvanced() {
            $ctrl.showAdvancedSetting = !$ctrl.showAdvancedSetting;
        }
    }

    var ServiceItemSchedules = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-schedules/partial-form.service-item-schedules.html',
        controller: ServiceItemSchedulesController,
        bindings: {
            serviceItemId: '<',
            selectedScheduleInfo: '='
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemSchedules', ServiceItemSchedules)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    ServiceItemSchedulesController.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService'];


})();

